// @see https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values

export const Hotkeys = {
  genomeViewer: {
    clearSelection: "C",
    toggleHeader: "Alt+\\",
    toggleFullscreen: "M",
    toggleToolbars: "N",
    search: "Alt+/",
  },
  files: {
    cut: "Control+X",
    copy: "Control+C",
    paste: "Control+V",
  },
  viewPane: {
    splitPaneLayoutChange: "Shift+T",
    toggleTable: "T",
  },
  navBar: {
    showShortcuts: "Control+Shift+?",
  },
  miniFocus: {
    focus: "Shift+S",
  },
  pagination: {
    right: "ArrowRight",
    rightWithOffset: "Shift+ArrowRight",
    left: "ArrowLeft",
    leftWithOffset: "Shift+ArrowLeft",
    home: "Shift+Home",
    end: "Shift+End",
  },
  navigationPanel: {
    collapse: "Control+\\",
  },
  pageHeader: {
    toggleToolsOpen: "Escape",
  },
  search: {
    open: "/",
  },
};
